import { z } from 'zod';

import { type RouteExportParams } from '~/types/router.type';

export const validateSearch = z.object({
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
});

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
};
